// components/Billing/Billing.jsx
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Divider } from "@mui/material";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import SpaIcon from "@mui/icons-material/Spa";

import BookingTab from "./bookings/BookingTab";
import RestaurantsTab from "./restaurants/RestaurantsTab";
import ExtrasTab from "./extras/ExtrasTab";
import Header from "../../components/Header";

const tabs = [
  { label: "Booking", icon: <HotelIcon />, path: "booking" },
  { label: "Restaurant", icon: <RestaurantMenuIcon />, path: "restaurant" },
  { label: "Extras", icon: <SpaIcon />, path: "extras" },
];

export default function Billing() {
  const navigate = useNavigate();
  const location = useLocation();

  // active tab index based on path
  const activeIndex =
    tabs.findIndex((t) => location.pathname.includes(t.path)) || 0;

  return (
    // <Box p={3} sx={{ width: "100%" }}>
      <Box component="main" sx={{ flexGrow: 1, p: 3, minWidth: 0 }}>
      <Header
        title="BILLING"
        subtitle="Manage charges for bookings, extras, and food"
      />

      {/* Tab navigation */}
      <Tabs
        value={activeIndex}
        onChange={(e, newValue) => navigate(tabs[newValue].path)}
      >
        {tabs.map((tab, i) => (
          <Tab key={i} icon={tab.icon} label={tab.label} iconPosition="start" />
        ))}
      </Tabs>

      <Divider sx={{ my: 2 }} />

      {/* Nested routes */}
      <Routes>
        <Route path="booking" element={<BookingTab />} />
        <Route path="restaurant" element={<RestaurantsTab />} />
        <Route path="extras" element={<ExtrasTab />} />
        <Route path="*" element={<BookingTab />} />
      </Routes>
    </Box>
  );
}
